// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./quill.core.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("7e2330e4", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/quill/dist/quill.core.css
// module id = 36
// module chunks = 0